import { createIcon } from "@chakra-ui/icons";

export const ArrowRightCircleIcon = createIcon({
  displayName: "ArrowRightCircleIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M12 16L16 12M16 12L12 8M16 12H8M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
});
